import api from "@/lib/api";

const CHUNK_SIZE = 512 * 1024; // 512KB raw per chunk — keeps requests well under proxy limits

function sliceToBase64(blob) {
  return new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(String(r.result).split(",")[1]);
    r.onerror = rej;
    r.readAsDataURL(blob);
  });
}

// Chunked upload: returns {file_id, name, mime, size}
export async function uploadFile(file, onProgress) {
  const total = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));
  const { data: start } = await api.post("/uploads/start", {
    filename: file.name,
    mime: file.type || "application/octet-stream",
    total_chunks: total,
  });
  for (let i = 0; i < total; i++) {
    const b64 = await sliceToBase64(file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE));
    await api.post(`/uploads/${start.upload_id}/chunk/${i}`, { data: b64 });
    onProgress?.(Math.round(((i + 1) / (total + 1)) * 100));
  }
  const { data } = await api.post(`/uploads/${start.upload_id}/complete`);
  onProgress?.(100);
  return data;
}
